// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infinite-scroll-container {
  position: relative;
  scroll-behavior: smooth;
}

.infinite-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.infinite-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.infinite-scroll-container::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-radius: 3px;
}

.infinite-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #b3b3b3;
}
`, "",{"version":3,"sources":["webpack://./src/components/InfiniteScroll/style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".infinite-scroll-container {\n  position: relative;\n  scroll-behavior: smooth;\n}\n\n.infinite-scroll-container::-webkit-scrollbar {\n  width: 6px;\n}\n\n.infinite-scroll-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 3px;\n}\n\n.infinite-scroll-container::-webkit-scrollbar-thumb {\n  background: #d9d9d9;\n  border-radius: 3px;\n}\n\n.infinite-scroll-container::-webkit-scrollbar-thumb:hover {\n  background: #b3b3b3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
